export default (that) => [
  // {
  //   field: 'seq',
  //   width: 50,
  //   align: 'center',
  //   fixed: 'left',
  //   type: 'seq',
  // },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_customsNo') || '报关发票号',
    field: 'customsNo',
    width: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    treeNode: true,
  },
  {
    title: that.$l('table_label_currencyAmount') || '计费金额',
    field: 'v_currencyAmount',
    align: 'center',
    width: 180,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_financeExpense') || '财务费用',
    field: 'v_expenseType',
    align: 'center',
    width: 150,
  },
  {
    title: that.$l('INDEX.item_label_orgDepFullName') || '分摊部门',
    field: 'orgDepFullName',
    width: 300,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },

  {
    title: that.$l('table_label_customer') || '客户',
    field: 'custName',
    width: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_brand') || '品牌',
    field: 'brandName',
    width: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_party') || '结算方',
    field: 'payScmName',
    width: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_payer') || '付款方',
    field: 'payerName',
    width: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_payScmBankName') || '结算方开户银行',
    field: 'bankName',
    width: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_payScmBankAccountName') || '结算方账户名称',
    field: 'bankAccountName',
    width: 260,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_payScmBankAccountNo') || '结算方银行账号',
    field: 'bankAccountNo',
    width: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_payScmBankAccountType') || '结算方银行账户性质',
    field: 'v_bankAccountType',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_payScmBankAccountKind') || '结算方银行账号类别',
    field: 'v_bankAccountKind',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_currencyUnit') || '货币单位',
    field: 'v_currencyUnit',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
]
